import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {SharedBoardsClient} from '@client/shared-boards-client'
import {
  useBoard,
  useForceUpdate,
  useLocationUpdateEffect,
  usePage,
  useSyncEvent
} from '@containers/hooks'
import {PageService} from '@extensions/page-service'
import {MainMenuContainer} from './main-menu-container'
import {useMainMenuStore} from './main-menu-store'

export const MainMenu = () => {
  const inFrame = window.parent !== window
  const inSharedBoard = !!SharedBoardsClient.getId()
  if (inFrame || inSharedBoard) {
    return null
  }

  return <MainMenuBase />
}

export const MainMenuBase = observer(() => {
  const board = useBoard()
  const page = usePage()
  const [state, store] = useMainMenuStore()
  const forceUpdate = useForceUpdate()
  const {menuOpen, canSeeStatsPage, canSeeLicensesPage} = state

  useEffect(() => {
    store.syncStateOnProfileChanged()
    store.syncStateOnCompanyChanged()
  }, [menuOpen, board, page])

  useSyncEvent('current', {debounceTime: 1100, filter: '*'}, () => {
    store.syncStateOnCompanyChanged()
    forceUpdate()
  })

  useSyncEvent('profile', {debounceTime: 1100, filter: '*'}, () => {
    store.syncStateOnProfileChanged()
    forceUpdate()
  })

  useLocationUpdateEffect(() => {
    store.syncStateOnProfileChanged()
    store.syncStateOnCompanyChanged()

    return true
  })

  if (!canSeeStatsPage && PageService.getPage() === 'statistics') {
    const subpage = PageService.getPath().split('/statistics/')[1]
    PageService.goToStatistics(subpage)
  }
  if (!canSeeLicensesPage && PageService.getPage() === 'billing') {
    PageService.goTo('projects')
  }

  return <MainMenuContainer />
})
